import NeedHelpModal from '@/components/modals/NeedHelpModal.vue';

export default {
  components: {
    NeedHelpModal,
  },
  // data() {
  //   return {
  //     showNeedHelpModal: false,
  //   }
  // },
  computed: {
    showNeedHelpModal() {
      return this.$store.state.showNeedHelpModal || false;
    },
  },
  methods: {
    onCloseNeedHelpModal() {
      // this.showNeedHelpModal = false;
      this.$store.commit('setShowNeedHelpModal', false);
    },
    openNeedHelpModal() {
      // this.showNeedHelpModal = true;
      this.$store.commit('setShowNeedHelpModal', true);
    },
  },
};
